export const isDVRStreamType = (metaData, channel) => {
    return (
        (metaData.videoProperties &&
            ((typeof metaData.videoProperties === 'string' &&
                metaData.videoProperties.indexOf('DVR') > 0) ||
                (typeof metaData.videoProperties === 'object' &&
                    metaData.videoProperties.includes('DVR')))) ||
        channel?.isLTSEnabled
    );
};
